<script>
import { menuItems } from "../../../../../components/menu.js";
import { USERSPATH } from "../../../../../path";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "permissions",
  props: ["user", "permissions"],
  data() {
    return {
      fields: ["name"],
      items: [],
      permissions_data: menuItems,
      allMenuPermissionsArr: [],
      extraPermissions: [],
      selected_permissions: [],
      key: 1,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  mounted() {
    if (this.permissions && this.permissions.length > 0) {
      this.selected_permissions = this.permissions.map((p) => p.name);
    }
    this.getPermissions();
    this.getAllPermissions(this.permissions_data);
  },
  watch: {
    selected_permissions() {},
  },
  methods: {
    // changeAuthorization(row) {
    //   console.log(row);
    // },
    async getPermissions() {
      try {
        let res = await axios.get(this.baseUrl + USERSPATH.GET_PERMISSIOINS);

        if (res.data.status) {
          this.setExtraPermissions(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },

    setExtraPermissions(all) {
      this.extraPermissions = all.filter((permission) => {
        let index = this.allMenuPermissionsArr.indexOf(permission.name);
        return index == -1;
      });
    },

    getAllPermissions(arr) {
      let permissions = [];

      function extractPermissions(items) {
        items.forEach((item) => {
          if (item.permission) {
            permissions.push(item.permission);
          }
          if (item.subItems && item.subItems.length > 0) {
            extractPermissions(item.subItems);
          }
        });
      }

      extractPermissions(arr);
      this.allMenuPermissionsArr = permissions;
    },
    setExtraPermission(m, mi, e) {
      if (e == true) {
        let exists = this.selected_permissions.indexOf(m.name);
        if (exists == -1) {
          this.selected_permissions.push(m.name);
        }
      } else {
        let index = this.selected_permissions.indexOf(m.name);
        if (index !== -1) {
          this.selected_permissions.splice(index, 1);
        }
      }
      console.log(this.selected_permissions, "selected Permission");
    },
    setMainPermission(m, mi, e) {
      if (e == true) {
        let exists = this.selected_permissions.findIndex(
          (f) => f == m.permission
        );
        if (exists == -1) {
          this.selected_permissions.push(m.permission);
        }
      } else {
        let index = this.selected_permissions.findIndex(
          (f) => f == m.permission
        );
        if (index !== -1) {
          delete this.selected_permissions[index];
        }
      }
      let ps = this.permissions_data
        .filter((f) => f.permission == m.permission)
        .map((s) => s.subItems?.map((ss) => ss.permission));
      ps.forEach((p) => {
        p.forEach((p) => {
          let i = this.selected_permissions.findIndex((f) => f == p);
          if (e == true) {
            if (i == -1) {
              this.selected_permissions.push(p);
            }
          } else {
            delete this.selected_permissions[i];
          }
        });
      });
      this.key += 1;
    },
    //     setMainPermission(m, mi, e) {
    //   const permissionIndex = this.selected_permissions.indexOf(m.permission);
    //   if (e) {
    //     if (permissionIndex === -1) {
    //       this.selected_permissions.push(m.permission);
    //     }
    //   } else {
    //     if (permissionIndex !== -1) {
    //       this.selected_permissions.splice(permissionIndex, 1);
    //     }
    //   }

    //   const subPermissions = this.permissions_data
    //     .filter((f) => f.permission == m.permission)
    //     .flatMap((s) => s.subItems?.map((ss) => ss.permission) || []);

    //   subPermissions.forEach((subPermission) => {
    //     const subPermissionIndex = this.selected_permissions.indexOf(subPermission);
    //     if (e) {
    //       if (subPermissionIndex === -1) {
    //         this.selected_permissions.push(subPermission);
    //       }
    //     } else {
    //       if (subPermissionIndex !== -1) {
    //         this.selected_permissions.splice(subPermissionIndex, 1);
    //       }
    //     }
    //   });

    //   this.key += 1;
    // },
    setSubPermission(s, si, e) {
      let ps = this.findParentPermission(this.permissions_data, s.permission);
      let i = this.selected_permissions.findIndex((f) => f == ps);
      if (e == true) {
        if (i == -1) {
          this.selected_permissions.push(ps);
        }
        if (
          this.selected_permissions.findIndex((f) => f == s.permission) == -1
        ) {
          this.selected_permissions.push(s.permission);
        }
      } else {
        let ii = this.selected_permissions.findIndex((f) => f == s.permission);
        if (ii !== -1) {
          delete this.selected_permissions[ii];
        }
        if (i !== -1) {
          let all_permissions = this.permissions_data
            .filter((f) => f.permission == ps)
            .map((s) => s.subItems?.map((ss) => ss.permission));
          let exists = false;
          all_permissions.forEach((a) => {
            a.forEach((a) => {
              if (this.selected_permissions.includes(a)) {
                exists = true;
                return;
              }
            });
          });
          if (!exists) {
            delete this.selected_permissions[i];
          }
        }
      }
      this.key += 1;
    },
    findParentPermission(menuItems, targetPermission) {
      for (const item of menuItems) {
        if (item.subItems) {
          for (const subItem of item.subItems) {
            if (subItem.permission === targetPermission) {
              return item.permission; // Return parent permission if found
            } else if (subItem.subItems) {
              const parentPermission = this.findParentPermission(
                subItem.subItems,
                targetPermission
              );
              if (parentPermission) {
                return parentPermission; // Return parent permission if found in nested subItems
              }
            }
          }
        }
      }
      return null; // Return null if parent permission not found
    },
    setSubSubPermission(ss, e) {
      let data = this.selected_permissions.findIndex((f) => f == ss);
      if (data !== -1) {
        if (e == false) {
          delete this.selected_permissions[data];
        }
      } else {
        if (e == true) {
          this.selected_permissions.push(ss.permission);
        }
      }
    },
    async savePermissions() {
      try {
        let res = await axios.post(this.baseUrl + USERSPATH.SYNC_PERMISSIONS, {
          user_id: this.user.id,
          permissions: this.selected_permissions,
        });
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.$emit("update");
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error.message, "", "error");
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="mb-0">
      <div class="row">
        <div
          class="col-4 card"
          v-for="(m, mi) in permissions_data.filter((f) => f.id != 1)"
          :key="mi"
        >
          <div :key="key">
            <b-checkbox
              :checked="
                selected_permissions.filter((f) => f == m.permission).length > 0
              "
              @change="setMainPermission(m, mi, $event)"
              >{{ m.label }}</b-checkbox
            >
            <div
              style="margin-left: 20px"
              v-if="m.subItems && m.subItems.length > 0"
            >
              <div v-for="(s, si) in m.subItems" :key="si + mi">
                <b-checkbox
                  :checked="
                    selected_permissions.filter((f) => f == s.permission)
                      .length > 0
                  "
                  @change="setSubPermission(s, si, $event)"
                  >{{ s.label }}</b-checkbox
                >
                <div
                  style="margin-left: 20px"
                  v-if="s.subItems && s.subItems.length > 0"
                >
                  <b-checkbox
                    v-for="(ss, ssi) in s.subItems"
                    :checked="
                      selected_permissions.filter((f) => f == ss.permission)
                        .length > 0
                    "
                    :key="ssi + si + mi"
                    @change="setSubSubPermission(ss, $event)"
                    >{{ ss.label }}</b-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px">
      <div class="col-4" v-for="(m, mi) in extraPermissions" :key="mi">
        <b-checkbox
          :checked="selected_permissions.filter((f) => f == m.name).length > 0"
          @change="setExtraPermission(m, mi, $event)"
          >{{ m.name }}</b-checkbox
        >
      </div>
    </div>
    <b-button variant="success" @click="savePermissions"
      >Save Permissions</b-button
    >
  </div>
</template>

<style></style>
